import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { RootStoreContext } from "stores/RootStore";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

interface RequireAuthProps {
  children: JSX.Element;
}

const RequireAuth: React.FC<RequireAuthProps> = observer(({ children }) => {
  const {
    authStore: { logout, currentUser },
    isHydrated,
  } = useContext(RootStoreContext);

  if (!isHydrated) {
    return null;
  }

  if (!currentUser) {
    logout();

    return <Navigate to="/login" />;
  }

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      {children}
    </QueryParamProvider>
  );
});

export default RequireAuth;
